'use strict';

/* Slick Carousel */
import 'slick-carousel';

require('!style-loader!css!slick-carousel/slick/slick.css');

let prevArrow = '<button type="button" class="slick-prev" aria-label="Précédent"><i class="fa-regular fa-arrow-left"></i></button>';
let nextArrow = '<button type="button" class="slick-next" aria-label="Suivant"><i class="fa-regular fa-arrow-right"></i></button>';

// eslint-disable-next-line no-unused-vars
let breakpoints = {
    'sm': 575,
    'md': 767,
    'lg': 991,
    'xl': 1199,
    'xxl': 1549,
    '3xl': 1799,
};

(function ($) {
    $(window).on('load statechangecomplete', function () {

        $('.slick-gallery').each(function () {
            $(this).slick({
                rows: 0,
                arrows: true,
                appendArrows: $('.slick-nav-arrows', $(this).parent()),
                prevArrow: prevArrow,
                nextArrow: nextArrow,
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                swipeToSlide: true,
            });
        });

        $('.slider-testimonials').each(function () {
            $(this).slick({
                rows: 0,
                arrows: true,
                appendArrows: $('.nav-arrows', $(this).parent()),
                prevArrow: prevArrow,
                nextArrow: nextArrow,
                dots: true,
                appendDots: $('.testimonials-nav-wrapper'),
                slidesToShow: 1,
                slidesToScroll: 1,
                swipeToSlide: true,
                infinite: true,
                speed: 500
            });
        });

        $('.slider-logos.to-left').each(function () {
            $(this).slick({
                arrows: false,
                dots: false,
                slidesToShow: 6,
                centerMode: true,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 0,
                speed: 8000,
                pauseOnHover: false,
                cssEase: 'linear',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            speed: 9000,
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 1440,
                        settings: {
                            slidesToShow: 5,
                        }
                    }
                ]
            });
        });

        $('.slider-logos.to-right').each(function () {
            $(this).slick({
                arrows: false,
                dots: false,
                slidesToShow: 6,
                centerMode: true,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 0,
                speed: 8000,
                cssEase: 'linear',
                rtl:true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 1440,
                        settings: {
                            slidesToShow: 5,
                        }
                    },
                ]
            });
        });

        $('.slider-clients.images').each(function () {
            $(this).slick({
                centerMode: true,
                variableWidth: true,
                infinite: true,
                slidesToShow:3,
                slidesToScroll:1,
                prevArrow: $('.prev-client'),
                nextArrow: $('.next-client'),
                dots: true,
                appendDots: $('.dots-clients'),
                asNavFor: $('.slider-clients.content'),
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                ]
            })
        });

        $('.slider-clients.content').each(function () {
            $(this).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: false,
                arrows: false
            })
        });

        $('.gallery-variable').each(function () {
            $(this).slick({
                variableWidth: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: true,
                infinite: true,
                arrows: false,
                dots: false,
                autoplay: true,
                autoplaySpeed: 0,
                speed: 7000,
                cssEase: 'linear',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                ]
            })
        })

    });
})(jQuery);


// WEBPACK FOOTER //
// ./scripts/slick-carousel.js